import { render, staticRenderFns } from "./addPay.vue?vue&type=template&id=b4ffdd6c&scoped=true&"
import script from "./addPay.vue?vue&type=script&lang=js&"
export * from "./addPay.vue?vue&type=script&lang=js&"
import style0 from "./addPay.vue?vue&type=style&index=0&id=b4ffdd6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ffdd6c",
  null
  
)

export default component.exports